import type { TowerDesign } from "@/game/towerSpec";

/**
 * Multi-segment self-supporting lattice — demonstrates the `segments` format:
 * a heavy, wide, heavily-braced base section, a medium mid section, and a light
 * tapering top, each with its own sections/bracing (like a real stepped tower).
 * Base width 7 m at 50 m → base/height ≈ 1/7.
 */
export const design: TowerDesign = {
  id: "lattice-stepped-50m",
  name: "Stepped Lattice",
  description: "50 m multi-segment lattice: heavy base → light top.",
  spec: {
    type: "lattice",
    height: 50,
    segments: {
      faces: 4,
      baseRadius: 3.5,
      sections: [
        // heavy braced base — carries the overturning couple
        { toHeight: 20, topRadius: 2.2, panels: 6, legSection: "legXL", braceSection: "braceHeavy", bracing: "X" },
        // medium mid section
        { toHeight: 40, topRadius: 1.0, panels: 6, legSection: "legHeavy", braceSection: "braceMed", bracing: "X" },
        // light tapering top
        { toHeight: 50, topRadius: 0.6, panels: 4, legSection: "legMed", braceSection: "braceLight", bracing: "X" },
      ],
    },
  },
};
